export enum SIGNUP_STEPS {
    PHONE = "phone",
    PHONEOTP = "phoneotp",
    EMAIL = "email",
    EMAILOTP = "emailotp",
    QUESTION1 = 'question1',
    QUESTION2 = 'question2',
    QUESTION3 = 'question3'
}

export enum SIGNUP_URL_PARAMS {
    REF_CODE_PARAM = "ref_code",
    UTM_ICM_PARAM = "utm_incred_params",
    UTM_SOURCE = "utm_source",
    UTM_MEDIUM = "utm_medium",
    UTM_CAMPAIGN = "utm_campaign",
    REFERRER_SOURCE = "referrer_source",
    UTM_TERM = "utm_term",
    UTM_CONTENT = "utm_content",
    BRANCH_MATCH_ID = "_branch_match_id",
    BRANCH_REFERRER = "_branch_referrer"
}

export enum SIGNUP_NPS_QUES_STATUS {
    SUBMITTED = 'submitted'
}

export enum SIGNUP_TYPE {
    MOBILE_SIGNUP = 'mobileSignup',
    MOBILE_LOGIN = 'mobileLogin',
    EMAIL_OTP_LOGIN = 'emailOtpLogin'
}